import { writable } from "svelte/store";
const store = writable({ show: false, snippet: null, timeout: null });
export const SnippetCreatedModalStore = {
    subscribe: store.subscribe,
    show(snippet, timeout = 4000) {
        store.set({ show: true, snippet, timeout });
        setTimeout(() => {
            store.set({ show: false, snippet: null, timeout: null });
        }, timeout);
    },
    hide() {
        store.set({ show: false, snippet: null, timeout: null });
    }
};
